import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  details: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: 8,
  },
  detailItem: {
    fontFamily: "open-sans",
    marginHorizontal: 4,
    fontSize: 12,
  },
});

export default styles;
